import { Component } from 'preact';
import SubHeader from '../layout/subheader/';
require('./index.scss');

/*
class Related extends Component {

	constructor(props) {
		super(props);
		this.state = {
			products: [],
			loading:false
		};
	}
	fetchRelatedProducts(related,products,loading){
        if (!!related && related.length && !products.length && !loading){
            this.setState({loading:true});
            Promise.all(related.sort(()=>{
                // random-ish-ize array
                return .5 - Math.random();
            }).filter((item,index)=>{
                // get first 4 items
                return index < 4;
            }).map(unique =>
                // fetch products
				fetch(`https://charlottefilshie.com/${unique}?json=true`).then(resp => {
					try {
						return resp.json();
					} catch (e) {
						return {};
					}
				})
            )).then(products => {
                this.setState({products, loading:false});
            }).catch(e => {
				this.setState({loading:false});
			});

        }
	}
    componentWillMount(props,state){
        console.log('componentWillMount', this.props, this.state);

        const {products, loading} = this.state;
        const {related} = this.props;
        console.log('componentWillUpdate', this.props);

		this.fetchRelatedProducts(related,products,loading);

	}
    componentDidMount(props){
        console.log('componentDidMount',props);
    }
	componentWillUpdate(props) {

        const {products, loading} = this.state;
        const {related} = props;

        this.fetchRelatedProducts(related,products,loading);
	}

	renderProducts(){
		const {products} = this.state;

		if(!products.length){
			return (<h3>There are no related products</h3>);
		}
		return products.map(product => {
            let prod = product.breadcrumbs[product.breadcrumbs.length-1];
            let inStock = product.stock === 'In Stock';
			return (
				<a className="related-product" href={prod.href || null} target="_blank">
                    <img src={product.thumb} />
					<span className={'related-product__title'}>{product.heading_title}</span>
					<span className={'related-product__price'}>{product.price}</span>

				</a>
			)
		})
	}


	render(){

		let {products, loading} = this.state;

		if (loading){
			return (<h3 className={'related-products__loading'}>Loading</h3>);
		}

		if(!products.length){
			return null;
		}

		return (
			<div className="related-products__wrapper">
                <SubHeader heading={'Related Products'} />
                <div className="related-products">
					{this.renderProducts()}
				</div>
			</div>
		);
	}
}
*/

class Related extends Component {
	render() {
		return null;
	}
}
export default Related;



// WEBPACK FOOTER //
// ./components/related/index.js